"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CsvFormatterStream = void 0;
var stream_1 = require("stream");
var formatter_1 = require("./formatter");
var CsvFormatterStream = /*#__PURE__*/function (_stream_1$Transform) {
  function CsvFormatterStream(formatterOptions) {
    var _this;
    _classCallCheck(this, CsvFormatterStream);
    _this = _callSuper(this, CsvFormatterStream, [{
      writableObjectMode: formatterOptions.objectMode
    }]);
    _defineProperty(_this, "formatterOptions", void 0);
    _defineProperty(_this, "rowFormatter", void 0);
    _defineProperty(_this, "hasWrittenBOM", false);
    _this.formatterOptions = formatterOptions;
    _this.rowFormatter = new formatter_1.RowFormatter(formatterOptions);
    // if writeBOM is false then set to true
    // if writeBOM is true then set to false by default so it is written out
    _this.hasWrittenBOM = !formatterOptions.writeBOM;
    return _this;
  }
  _inherits(CsvFormatterStream, _stream_1$Transform);
  return _createClass(CsvFormatterStream, [{
    key: "transform",
    value: function transform(transformFunction) {
      this.rowFormatter.rowTransform = transformFunction;
      return this;
    }
  }, {
    key: "_transform",
    value: function _transform(row, encoding, cb) {
      var _this2 = this;
      var cbCalled = false;
      try {
        if (!this.hasWrittenBOM) {
          this.push(this.formatterOptions.BOM);
          this.hasWrittenBOM = true;
        }
        this.rowFormatter.format(row, function (err, rows) {
          if (err) {
            cbCalled = true;
            return cb(err);
          }
          if (rows) {
            rows.forEach(function (r) {
              _this2.push(Buffer.from(r, 'utf8'));
            });
          }
          cbCalled = true;
          return cb();
        });
      } catch (e) {
        if (cbCalled) {
          throw e;
        }
        cb(e);
      }
    }
  }, {
    key: "_flush",
    value: function _flush(cb) {
      var _this3 = this;
      this.rowFormatter.finish(function (err, rows) {
        if (err) {
          return cb(err);
        }
        if (rows) {
          rows.forEach(function (r) {
            _this3.push(Buffer.from(r, 'utf8'));
          });
        }
        return cb();
      });
    }
  }]);
}(stream_1.Transform);
exports.CsvFormatterStream = CsvFormatterStream;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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